<section class="subheader doble-m min quicksand" #containerPortadaFicha>
    <div class=" card-title quicksand" id="card-title" #cardTitle [style.backgroundColor]="datos.color">

        <div class="float-left title-section" id="title-section">
            <div #tag *ngIf="datos.tag" class="etiqueta-nueva"><span
                    class="tag quicksand-regular text-center">{{datos.tag}}</span></div>
            <div id="titles-section" [style.padding-top]="(datos.tag) ? '24px':'0px'"
                class="titles-section d-flex flex-row align-items-start">

                <div class="d-flex flex-column align-items-start" [style.width]="'100%'">
                    <h5 id="title-font" class="blanco quicksand-medium title-card ">
                        <img *ngIf="svgContent" [src]="svgContent" alt="" class=" university-icon">

                        {{datos.title | uppercase}}
                    </h5>
                    <div  *ngIf="datos.subtitle " class='subtitle-section'>
                        <h2 id="subtitle-font" class="blanco quicksand-medium subtitle" *ngIf="posgrado || continua">
                            {{datos.subtitle }}
                        </h2>
                    </div>
                    <span class='link-section'>
                        <span>
                            <a (click)="goToLink(item)" class="blanco quicksand-medium linksUniversity"
                                *ngFor="let item of region">
                                {{ item.title }}
                            </a>
                        </span>
                        <span>
                            <a [href]="datos.venue?.link" class="blanco quicksand-medium linksUniversity"
                                *ngIf="viewVenue" target="_blank" rel="noopener noreferrer">
                                | {{datos.venue?.title}}
                            </a>
                        </span>


                        <span *ngIf="posgrado">
                            <a [href]="datos.link" *ngIf="viewArea" class="blanco quicksand-medium linksUniversity"
                                target="_blank" rel="noopener noreferrer">
                                | {{datos.area[0]?.name}}
                            </a>
                        </span>
                        <span *ngIf="!posgrado">
                            <a [href]="'/es/'+ datos.area_tematica[0]?.url " *ngIf="viewArea"
                                class="blanco quicksand-medium linksUniversity" target="_blank"
                                rel="noopener noreferrer">
                                | {{datos.area_tematica[0]?.name}}
                            </a>
                        </span>
                    </span>

                </div>

                <div class="d-flex flex-column align-items-start desk">
                    <a [style.color]="datos.color" target="_blank" class="fs-26 btn btn-primary nunito-bold zoomIn"
                        *ngIf="datos.button_signUp_state" [href]="datos.button_signUp">INSCRIBITE</a>
                    <a *ngIf="!datos.button_signUp_state" class="btn btn-primary nunito-bold"
                        [style.color]="datos.color" (click)="openModalConsulta()">
                        QUIERO MÁS INFO
                    </a>
                </div>

            </div>
            <div class=" flex-column align-items-center mob-flex">
                <a [style.color]="datos.color" [style.margin]="'50px auto'" target="_blank"
                    class="fs-26 btn btn-primary nunito-bold zoomIn" *ngIf="datos.button_signUp_state"
                    [href]="datos.button_signUp">INSCRIBITE</a>
                <a *ngIf="!datos.button_signUp_state" class="btn btn-primary nunito-bold" [style.color]="datos.color"
                    (click)="openModalConsulta()">
                    QUIERO MÁS INFO
                </a>
            </div>
        </div>

    </div>
</section>


<!-- Sticky Header: aparece al hacer scroll -->
<div class="sticky-header" id="sticky-header" *ngIf="showStickyHeader" [style.backgroundColor]="datos.color">
    <div class="sticky-content">
        <div [style.width]="'100%'" [style.align-items]="'center'" [style.display]="'flex'">
            <img *ngIf="svgContent" id="icon-sticky" [src]="svgContent" alt="" class=" university-icon">

            <span class="sticky-title quicksand-regular" id="title-font-sticky">{{ datos?.title }} </span>



        </div>
        <a [href]="datos.button_signUp" target="_blank" class="btn btn-primary nunito-bold" [style.color]="datos.color"
            *ngIf="datos.button_signUp_state && (venue!='facultad-de-teologia' && carrer!='ingenieria-electronica')">
            INSCRIBITE
        </a>
        <a *ngIf="!datos.button_signUp_state" class="btn btn-primary nunito-bold" [style.color]="datos.color"
            (click)="openModalConsulta()">
            QUIERO MÁS INFO
        </a>

    </div>
</div>